import Axios from "@/utils/Axios";
import config from "@/config";

export interface GetMessageListType {
  page_size: number;
  page_index: number;
}

export function messageList(data: GetMessageListType) {
  return Axios.post("/ai_creator/message/list", data, {}, config.gwURL);
}

export function setMsgRead(data: { id: number }) {
  return Axios.post("/ai_creator/message/update_read_status", data, {}, config.gwURL);
}

export function setMsgAllRead() {
  return Axios.post("/ai_creator/message/set_all_read_status", {}, {}, config.gwURL);
}

export function getImgDetail(data: { image_id: number }) {
  return Axios.post("/ai_creator/opus/image_detail", data, {}, config.gwURL);
}

export function opusExit(data: { image_id: number; opus_id: number }) {
  return Axios.post("/ai_creator/opus/image_exist", data, {}, config.gwURL);
}

export function mySpaceOpusDetail(data: { opus_id: number }) {
  return Axios.post("/ai_creator/opus/my_space_detail", data, {}, config.gwURL);
}
